import { KnockProvider } from "@knocklabs/react";
import { isNonEmptyString } from "@clipboard-health/util-ts";
import { environmentConfig } from "@src/appV2/environment";
import { knock } from "@src/appV2/environment/config";
import { type ReactNode } from "react";

import {
  KnockGuideProviderWithRefetch,
  type KnockGuideProviderWithRefetchProps,
} from "./KnockGuideProviderWithRefetch";

interface KnockProviderWrapperProps {
  children: ReactNode;
  guideConsumers: ReactNode;
  userId: string | undefined;
  knockToken: string | undefined;
  onUserTokenExpiring: () => Promise<string | undefined>;
  targetParams?: KnockGuideProviderWithRefetchProps["targetParams"];
}

/**
 * Keeps the application and Knock subtree mounted at stable React positions
 * while deferring client activity until the identity is complete.
 */
export function KnockProviderWrapper(props: KnockProviderWrapperProps) {
  const { children, guideConsumers, userId, knockToken, onUserTokenExpiring, targetParams } = props;
  const isKnockEnabled = isNonEmptyString(userId) && isNonEmptyString(knockToken);

  return (
    <>
      {children}
      <KnockProvider
        apiKey={environmentConfig.REACT_APP_KNOCK_PUBLIC_API_KEY}
        user={{ id: userId }}
        userToken={knockToken}
        onUserTokenExpiring={onUserTokenExpiring}
        enabled={isKnockEnabled}
      >
        <KnockGuideProviderWithRefetch
          readyToTarget
          channelId={knock.channels.guides}
          targetParams={targetParams}
        >
          {guideConsumers}
        </KnockGuideProviderWithRefetch>
      </KnockProvider>
    </>
  );
}
